import { render, staticRenderFns } from "./ArticleBrowsingRecordList.vue?vue&type=template&id=670e9d81&scoped=true"
import script from "./ArticleBrowsingRecordList.vue?vue&type=script&lang=js"
export * from "./ArticleBrowsingRecordList.vue?vue&type=script&lang=js"
import style0 from "./ArticleBrowsingRecordList.vue?vue&type=style&index=0&id=670e9d81&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670e9d81",
  null
  
)

export default component.exports